import React from "react";
import styles from "./customButton.module.scss";
import { Button } from "@mui/material";

const CustomButton = ({
  title,
  txtClr,
  bgclr,
  fontSize,
  startIcon,
  width,
  height,
  borderRadius,
  fontWeight,
  onClick,
  endIcon,
  background,
  variant,
  disabled,
  padding,
}) => {
  return (
    <div className={styles.container}>
      <Button
        disabled={disabled}
        variant={variant || "contained"}
        startIcon={startIcon}
        endIcon={endIcon}
        style={{
          fontSize: fontSize,
          color: txtClr,
          backgroundColor: bgclr || null,
          background: background,
          fontWeight: fontWeight,
          width: width,
          height: height,
          borderRadius: borderRadius,
          padding:padding,
        }}
        onClick={onClick}
      >
        {title}
      </Button>
    </div>
  );
};

export default CustomButton;
